import Stream from '../libs/Stream';


let increaseOrderItemCountActionStream: Stream<number> = new Stream() as Stream<number>;

export default increaseOrderItemCountActionStream;
